import React from 'react'
import { Create } from 'react-admin'

import CompetitionsForm from './form'

export const ClubsCreate = (props) => (
  <Create {...props}>
    <CompetitionsForm isEdit={false} {...props} />
  </Create>
)

export default ClubsCreate
